export enum CommissionAdvanceStatus {
  ACTIVE = "ACTIVE",
  OVERDUE = "OVERDUE",
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
}

export enum CommissionAdvanceCancellationReason {
  OVERDUE_PAYMENTS = "OVERDUE_PAYMENTS",
  LAST_PAYMENT_OVERDUE = "LAST_PAYMENT_OVERDUE",
  CONTRACT_TERMINATED = "CONTRACT_TERMINATED",
  AGENT_COOPERATION_ENDED = "AGENT_COOPERATION_ENDED",
  CONTRACT_PARAMETERS_CHANGED = "CONTRACT_PARAMETERS_CHANGED",
  CONTRACT_GAINERS_CHANGED = "CONTRACT_GAINERS_CHANGED",
}

export enum CommissionAdvanceInputType {
  PAYOUT = "PAYOUT",
  MERGED = "MERGED",
  CONSUMED = "CONSUMED",
}
